import React, { useState } from "react";
import './style.css';

const Question = () => {
  const [isLoading, setIsLoading] = useState(true); // 로딩 상태 관리

  // iframe 로드 완료 시 호출
  const handleLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className="question">
      {isLoading && ( 
        <div className="loading-message">
            <p className="loader"></p>
            <h3>로딩중</h3>
            <strong>잠시만 기다려주세요.</strong>
        </div>
      )}
      
      <div className="q-box">
      <iframe onLoad={handleLoad} loading="lazy"
      src="https://form.naver.com/response/ABsExkXeuKZuPWaLdj3alg" 
      title="문의하기"
      width="100%" height="631" frameBorder="0" marginHeight="0" marginWidth="0" style={{marginTop:'1em'}}>
      </iframe>
    </div>
    </div>
  );
};

export default Question;